const mainMenuButton = document.querySelector('.header__icon--menu');


/*
// Check if the element exists before applying styles
if (mainMenuButton) {
  mainMenuButton.style.border = '2px solid blue';
}


if (mainMenuButton) {
  // Function to handle changes to aria-expanded
  function handleAriaExpandedChange() {
    const isExpanded = mainMenuButton.getAttribute('aria-expanded') === 'true';
    var subMenus = document.querySelectorAll('summary.menu-drawer__menu-item');
    
          console.log("Is Expanded: " + isExpanded + " Length: " + subMenus.length);

     // Set aria-hidden for each submenu
    subMenus.forEach(subMenu => {
      subMenu.setAttribute('aria-hidden', !isExpanded);
    });
  }

  // Initialize MutationObserver to watch for changes in attributes
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
        handleAriaExpandedChange();
      }
    }
  });

  // Start observing the main menu button for attribute changes
  observer.observe(mainMenuButton, { attributes: true });
}

*/